<template>
  <div class="addbank">
    <div class="title">
      银行管理 <span>{{titlename}}银行信息</span>
    </div>
    <div class="main">
      <div class="addBankInfo">{{titlename}}银行信息</div>
      <div class="bankContent">
        <div class="banklist">
          <label for="bankname">
            <span>*</span>银行名称
          </label>
          <el-input size="small"
                    placeholder="请输入银行名称"
                    v-model="bankInfo.bankName"></el-input>
        </div>
        <div class="banklist">
          <label for="banknum"><span>*</span>银行编码</label>
          <el-input size="small"
                    v-model="bankInfo.bankNum"></el-input>
        </div>
        <div class="bankBtn">
          <button class="save"
                  @click="handleAddBankClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addBank, saveBank, updateBank } from '../../apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'addbank',
  data () {
    return {
      titlename: '添加',
      bankInfo: {
        bankId: ''
      }
    }
  },
  // computed: mapState({
  //   bankInfo: state => state.bank.bankInfo
  // }),
  methods: {
    getData () {
      updateBank({
        bankId: this.bankInfo.bankId
      }).then(res => {
        if (res.data.code === 0) {
          this.bankInfo = res.data.data.vhbBankName
        }
      })
    },
    handleAddBankClick () {
      const bankNum = this.bankInfo.bankNum ? this.bankInfo.bankNum : ''
      const bankName = this.bankInfo.bankName ? this.bankInfo.bankName : ''
      const bankId = this.bankInfo.bankId ? this.bankInfo.bankId : ''
      const createTime = this.bankInfo.createTime ? this.bankInfo.createTime : ''
      if (this.bankInfo.bankId) { // 修改
        saveBank({ bankId, bankNum, bankName, createTime }).then(res => {
          if (res.data.code === 0 && res.status === 200) {
            this.$router.push({ path: '/manage/bank' })
          }
        })
      } else { // 添加
        addBank({ bankNum, bankName }).then(res => {
          if (res.data.code === 0) {
            this.$router.push({ path: '/manage/bank' })
          }
        })
      }
    },
    handleCancelClick () {
      this.$router.push({ path: '/manage/bank' })
    }
  },
  mounted () {
    this.bankInfo.bankId = this.$route.query.item
    if (this.bankInfo.bankId) {
      this.titlename = '修改'
      this.getData()
    }
  }
}
</script>
<style lang="stylus">
.addbank
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addBankInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../assets/images/03/add_icon.png') no-repeat center left 15px
    .bankContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .banklist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
      .bankBtn
        margin-left 116px
        margin-top 150px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
